import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateProviderSettingsBody } from "@shared-kernel/application/ports/admin/admin-repository";

export interface UpdateProviderSettingsParams {
  providerId: string;
  body: UpdateProviderSettingsBody;
}

export const updateProviderSettings = createAsyncThunk<string, UpdateProviderSettingsParams, { extra: Partial<Dependencies> }>(
  "admin/providers/updateSettings",
  async ({ providerId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateProviderSettings(providerId, body);
    return providerId;
  },
);

export const resetUpdateProviderSettings = createAction("admin/providers/resetUpdateSettings");
